export default __webpack_public_path__ + "static/media/012-camera.0798188a.svg";